module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-Light.7d3f181.woff";